module.exports = __webpack_public_path__ + "img/ethan_artona.974fb953.jpg";